import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SharedModule} from './shared/shared.module';
import {AuthModule} from "./pages/auth/auth.module";
import {ApiService} from './shared/services/api/api.service';
import {RolesService} from './shared/services/authorization-management/roles/roles.service';
import {provideStore, StoreModule} from "@ngrx/store";
import {EffectsModule, provideEffects} from "@ngrx/effects";
import {MenuGroupService} from "./pages/management/menu-management/services/menu-group.service";
import {appEffects, appReducer} from "./shared/store/store";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {AppointmentModule} from './pages/appointment/appointment.module';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {TokenInterceptor} from './shared/services/auth/interceptors/token.interceptor';
import {InstituationModule} from './pages/instituation/instituation.module';
import {VehicleControlModule} from './pages/vehicle-control/vehicle-control.module';
import {MedicalAdviceModule} from './pages/medical-advice/medical-advice.module';
import localeTr from '@angular/common/locales/tr';
import {registerLocaleData} from "@angular/common";
import {WorklistModule} from './pages/worklist/worklist.module';
import { CoreReportMatrisComponent } from './ui-components/core-report-matris/core-report-matris.component';
import { TeamStatusesComponent } from './pages/team-statuses/team-statuses.component';


registerLocaleData(localeTr, 'tr');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    StoreModule.forRoot(),
    EffectsModule.forRoot(),
    AuthModule,
    SharedModule,
    InstituationModule,
    AppointmentModule,
    VehicleControlModule,
    MedicalAdviceModule,
    WorklistModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    provideStore(appReducer),
    provideEffects(appEffects),
    ApiService,
    RolesService,
    MenuGroupService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
